import { render } from "./aReligion.vue?vue&type=template&id=5e638d2b"
import script from "./aReligion.vue?vue&type=script&lang=js"
export * from "./aReligion.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__